import type { Theme } from '@mui/material';

export const checkboxSx = {
  p: 0,
  mr: 10,
};
export const getCheckboxTypographySx = (theme: Theme) => ({
  ...theme.typography.body,
  color: theme.palette.accent,
});
export const formControlSx = {
  p: 10,
  pr: 0,
  m: 0,
}